var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@web/components/layout/Button';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { TableSortIcons } from '@web/components/layout/Table/TableSortIcons';
import { widgetMetricCellDurationText, widgetMetricTableColMetricValueStyle, widgetMetricTableDurationSlashClass, widgetMetricTableFigureValueSpanClass, widgetMetricTablePairHeaderThClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTablePeriodDiffRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { classNames, getApplicationIconByType, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { navigateToEventsLogForDateRange } from '@web/utility/chartNavigation';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { useWidgetTableSort } from '@web/utility/hooks/useWidgetTableSort';
import { buildMetricColumnIndexByField, buildWidgetTableSortingOption, sortWidgetTableRows } from '@web/utility/widgetTableSort';
import { ApplicationEnum, SortOrderEnum } from '@workalizer/shared';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { useTranslation } from 'react-i18next';
var mostFrequentPartnersCountDurationRowClass = 'flex w-full min-w-0 flex-nowrap items-baseline justify-start gap-x-1 pl-0 pr-0';
var mostFrequentPartnersValueDiffPair = [
    widgetMetricTableColMetricValueStyle,
    { width: '13%', minWidth: '5.25rem' }
];
var mostFrequentPartnersTableColgroup = __spreadArray(__spreadArray(__spreadArray(__spreadArray([
    { width: '18%' }
], mostFrequentPartnersValueDiffPair, true), mostFrequentPartnersValueDiffPair, true), mostFrequentPartnersValueDiffPair, true), mostFrequentPartnersValueDiffPair, true);
var metricSortColumns = [
    {
        field: 'gmails',
        app: ApplicationEnum.GMAIL,
        labelKey: 'app.performanceReview.employeePerformanceReview.communicationSection.tablesData.sentEmails'
    },
    {
        field: 'chats',
        app: ApplicationEnum.CHAT,
        labelKey: 'app.performanceReview.employeePerformanceReview.communicationSection.tablesData.googleChatMessages'
    },
    {
        field: 'meetings',
        app: ApplicationEnum.MEET,
        labelKey: 'app.performanceReview.employeePerformanceReview.communicationSection.tablesData.meetings'
    },
    {
        field: 'documents',
        app: ApplicationEnum.DRIVE,
        labelKey: 'app.performanceReview.employeePerformanceReview.communicationSection.tablesData.documentcomments'
    }
];
function getMostFrequentPartnerSortValue(partner, field) {
    var _a;
    switch (field) {
        case 'name':
            return (_a = partner.name) !== null && _a !== void 0 ? _a : '';
        case 'meetings':
            return partner.meetings.count;
        case 'documents':
            return partner.documents;
        case 'chats':
            return partner.chats;
        case 'gmails':
            return partner.gmails;
        case 'total':
            return (partner.chats +
                partner.meetings.count +
                partner.documents +
                partner.gmails);
        default:
            return 0;
    }
}
var metricColumnIndexByField = buildMetricColumnIndexByField(metricSortColumns.map(function (column) { return column.field; }), 0);
var sortColumnIndexByField = __assign(__assign({ name: 0 }, metricColumnIndexByField), { total: metricColumnIndexByField.gmails });
export var MostFrequentCommunicationPartners = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _b = useWidgetTableSort('total', SortOrderEnum.DESC), sortBy = _b.sortBy, displayedCount = _b.displayedCount, handleSortChange = _b.handleSortChange, loadMore = _b.loadMore;
    var _c = trpc.mostFrequentCommunicationPartners.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), data = _c.data, isLoading = _c.isLoading, refetch = _c.refetch;
    var allPartners = data !== null && data !== void 0 ? data : [];
    var sortedPartners = sortWidgetTableRows(allPartners, sortBy, getMostFrequentPartnerSortValue, { skipWhenField: 'total' });
    var partners = sortedPartners.slice(0, displayedCount);
    var hasMore = displayedCount < sortedPartners.length;
    if (isLoading && !data)
        return _jsx(Loading, {});
    var headerMetricClass = "".concat(widgetMetricTablePairHeaderThClass, " cursor-pointer");
    var headerNameClass = 'min-w-0 !text-left cursor-pointer';
    var columns = __spreadArray([
        {
            title: (_jsxs("span", __assign({ className: "inline-flex items-center gap-1" }, { children: [t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.name&Team'), _jsx(TableSortIcons, { isActive: sortBy.field === 'name', direction: sortBy.direction })] }))),
            isVisible: true,
            className: headerNameClass,
            orderByField: 'name'
        }
    ], metricSortColumns.map(function (_a) {
        var field = _a.field, app = _a.app, labelKey = _a.labelKey;
        return ({
            title: (_jsxs("div", __assign({ className: "flex min-w-0 items-center justify-start gap-2 text-left" }, { children: [getApplicationIconByType(app), _jsxs("span", __assign({ className: "inline-flex items-center gap-1" }, { children: [t(labelKey), _jsx(TableSortIcons, { isActive: sortBy.field === field, direction: sortBy.direction })] }))] }))),
            isVisible: true,
            colspan: 2,
            className: headerMetricClass,
            orderByField: field
        });
    }), true);
    var managerSuffix = t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.managerNameSuffix');
    var navigateToEventsLog = function () {
        navigateToEventsLogForDateRange({
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: userId,
            orgUnitId: orgUnitId
        });
    };
    var renderRow = function (item) {
        var _a;
        var rowKey = String(item.partnerUserId);
        var durationText = ((_a = item.meetings) === null || _a === void 0 ? void 0 : _a.duration)
            ? String(item.meetings.duration)
            : '';
        return [
            {
                id: "name-".concat(rowKey),
                className: classNames(widgetMetricTablePrimaryLabelTdClass, 'cursor-pointer'),
                render: function () { return (_jsxs("div", __assign({ className: "flex min-w-0 max-w-full cursor-pointer flex-col gap-1 font-semibold", onClick: navigateToEventsLog }, { children: [_jsxs("span", __assign({ className: "min-w-0 break-words" }, { children: [item.name, item.isManager ? (_jsxs("span", __assign({ className: "font-normal italic" }, { children: [" ", managerSuffix] }))) : null] })), _jsx("span", __assign({ className: "min-w-0 text-sm font-normal break-words text-gray-500" }, { children: item.orgUnitName }))] }))); }
            },
            {
                id: "gmails-value-".concat(rowKey),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: navigateToEventsLog }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: item.gmails })) }))); }
            },
            metricTablePeriodDiffRowCell("gmails-period-".concat(rowKey), item.gmailsDiff, TablesDiffColorsConfig.GREEN),
            {
                id: "chats-value-".concat(rowKey),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: navigateToEventsLog }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: item.chats })) }))); }
            },
            metricTablePeriodDiffRowCell("chats-period-".concat(rowKey), item.chatsDiff, TablesDiffColorsConfig.GREEN),
            {
                id: "meetings-value-".concat(rowKey),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () {
                    var _a, _b;
                    return (_jsxs("div", __assign({ className: classNames(mostFrequentPartnersCountDurationRowClass, 'cursor-pointer'), onClick: navigateToEventsLog }, { children: [_jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: (_b = (_a = item.meetings) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0 })), _jsx("span", __assign({ className: widgetMetricTableDurationSlashClass, "aria-hidden": "true" }, { children: "/" })), _jsx("span", __assign({ className: widgetMetricCellDurationText }, { children: durationText }))] })));
                }
            },
            metricTablePeriodDiffRowCell("meetings-period-".concat(rowKey), item.meetingsDiff, TablesDiffColorsConfig.GREEN),
            {
                id: "documents-value-".concat(rowKey),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: navigateToEventsLog }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: item.documents })) }))); }
            },
            metricTablePeriodDiffRowCell("documents-period-".concat(rowKey), item.documentsDiff, TablesDiffColorsConfig.GREEN)
        ];
    };
    var tableData = partners.map(renderRow);
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.communicationSection.mostFrequentCommunicationPartners'), description: t('widgetTitleDescriptions.communication.mostFrequentCommunicationPartners'), insightType: InsightTypeEnum.mostFrequentCommunicationPartners, insightsData: partners, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.communicationSection.mostFrequentCommunicationPartners'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, sortedPartners.map(function (item) {
                                    var _a;
                                    var _b, _c;
                                    return (_a = {},
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.name')] = "".concat(item.name).concat(item.isManager ? " ".concat(managerSuffix) : ''),
                                        _a[t('filters.orgUnit')] = item.orgUnitName,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.sentEmails')] = item.gmails,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.googleChatMessages')] = item.chats,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.meetings')] = (_b = item.meetings) === null || _b === void 0 ? void 0 : _b.count,
                                        _a[t('app.apps.searchMeetings.filters.duration')] = (_c = item.meetings) === null || _c === void 0 ? void 0 : _c.duration,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.documentcomments')] = item.documents,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(sortedPartners) }) }), _jsx(Table, { columns: columns, data: isInsightsDataEmpty(sortedPartners) ? [] : tableData, columnColStyles: mostFrequentPartnersTableColgroup, tableClassName: "table-auto w-full", rowClassName: "[&>td]:align-top", sortingOption: buildWidgetTableSortingOption(sortBy, sortColumnIndexByField, { hideWhenField: 'total' }), setSortingOption: handleSortChange }), hasMore && (_jsx("div", __assign({ className: "mt-4 flex justify-center" }, { children: _jsx(Button, __assign({ variant: "link", onClick: loadMore }, { children: t('loadMore') })) })))] })));
};
